import { type IngredientV2, type Tag } from '@hungryroot/rest';

function getTagIds(tags: Tag[] | number[] | undefined): number[] {
  if (!tags?.length) return [];
  if (typeof tags[0] === 'number') return tags as number[];
  return (tags as Tag[]).map((tag) => tag.id);
}

export function productContainsNeverTag(
  tags: Tag[] | number[] | undefined,
  neveredTagIds: Set<number>
): boolean {
  if (neveredTagIds.size === 0) return false;
  return getTagIds(tags).some((id) => neveredTagIds.has(id));
}

type NeverTagIngredient = {
  id: IngredientV2['id'];
  tags?: Tag[] | number[];
};

export function recipeContainsNeverTag(
  ingredients: NeverTagIngredient[],
  neveredTagIds: Set<number>,
  removedIngredientIds: number[] = []
): boolean {
  if (neveredTagIds.size === 0 || !ingredients?.length) return false;

  return ingredients.some(
    (ingredient) =>
      !removedIngredientIds.includes(ingredient.id) &&
      productContainsNeverTag(ingredient.tags, neveredTagIds)
  );
}
